exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider-dotted {\n  position: relative;\n  margin: 8px 0 8px 0;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 0.145rem dotted rgba(226, 230, 235, 0.85);\n}\n.text-bold {\n  font-weight: 600;\n  font-size: 1rem;\n}\n.text-color {\n  font-size: 12px !important;\n  color: rgba(6, 38, 62, 0.84) !important;\n}\n.text-empty-person {\n  margin-top: -8px;\n  color: #ea4e2c;\n  font-size: 13px;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}\n", ""]);

// exports
